import React, { memo, useCallback, useState } from 'react'
import tw from 'twin.macro'
import { showToast } from 'src/utils/toast'
import { handleApiError } from 'src/utils/errorHandlers'
import { Button } from 'src/components/shared/Button'
import { SendMajor } from '@shopify/polaris-icons'
import { TeamMemberInviteDetails } from 'src/interfaces/team'
import { colors } from 'src/theme'
import { ResendTeamMemberInvite } from 'src/constants/actionTypes'
import { createAsyncAction } from 'src/utils/reduxUtils'
import { useDispatch } from 'react-redux'

interface Props {
  teamMemberInviteDetails: TeamMemberInviteDetails
  onRefreshTeamMemberInvites(): Promise<void>
  onClose(): void
}

const TeamMemberInviteDetailsActionsComponent = ({
  teamMemberInviteDetails,
  onRefreshTeamMemberInvites,
  onClose,
}: Props) => {
  const dispatch = useDispatch()

  const [isLoading, setIsLoading] = useState(false)

  const handleResendInvite = useCallback(async () => {
    setIsLoading(true)

    try {
      await createAsyncAction(
        dispatch,
        ResendTeamMemberInvite.request({ teamMemberInviteId: teamMemberInviteDetails.id }),
      )

      showToast('Invite sent', { variant: 'success' })

      await onRefreshTeamMemberInvites()
      onClose()
    } catch (err) {
      handleApiError(err)
    } finally {
      setIsLoading(false)
    }
  }, [teamMemberInviteDetails.id])

  return (
    <div css={tw`flex flex-col p-4 pb-4`}>
      <div css={tw`w-full h-px bg-[#EDEDED] mb-4`} />
      <Button
        endIcon={isLoading ? null : <SendMajor width={20} fill={colors.PRIMARY_PURPLE_500} />}
        css={tw`w-full h-[36px] flex gap-0`}
        color="light"
        size="small"
        onClick={handleResendInvite}
        loading={isLoading}
      >
        Resend an invite
      </Button>
    </div>
  )
}

export const TeamMemberInviteDetailsActions = memo(TeamMemberInviteDetailsActionsComponent)
